var map = {
	"./act": 1542,
	"./act.ts": 1542,
	"./gmat": 1543,
	"./gmat.ts": 1543,
	"./gre": 1544,
	"./gre.ts": 1544,
	"./ielts": 1545,
	"./ielts.ts": 1545,
	"./ielts_general_training": 1546,
	"./ielts_general_training.ts": 1546,
	"./lsat": 1547,
	"./lsat.ts": 1547,
	"./mcat": 1548,
	"./mcat.ts": 1548,
	"./sat": 1549,
	"./sat.ts": 1549,
	"./toefl": 1550,
	"./toefl.ts": 1550
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2523;
module.exports = webpackAsyncContext;